import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { toast } from 'react-toastify';
import { getDialogIcon, getAlertType } from '../Common';

export function useNotification() {

    const toastId = React.useRef(null);


    const ToastTemplate = ({ closeToast, msg, msgType }) => {

        return (
            <div className={"alert has-icon alert-large text-left alert-dismissible pl-0 " + getAlertType(msgType)} style={{ "overflowY": "hidden" }} role="alert">
                <span className="has-icon pl-4"><i className={getDialogIcon(msgType)}></i></span>
                <div className="alert-content">
                    {msgType === "error" && (<h4 className="mb-0">Error</h4>)}
                    <p className="mb-0">{msg}</p>
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={closeToast}>
                        <span aria-hidden="true"><i className="fal fa-times-circle"></i></span>
                    </button>
                </div >
            </div>)
    }

    const notify = (msg, msgtype = "error") => {
        if (msg) {
            if (msgtype === "error") {
                if (!toast.isActive(toastId.current)) {
                    toastId.current = toast.error(<ToastTemplate msg={msg.info?.Message || msg.Message || msg.info || msg.status || msg} msgType={msgtype} />);
                }
            } else if (msgtype === "success") {
                toastId.current = toast.success(<ToastTemplate msg={msg} msgType={msgtype} />);
            }
            else if (msgtype === "warning") {
                toastId.current = toast.warn(<ToastTemplate msg={msg} msgType={msgtype} />);
            }
            else {

                toastId.current = toast.info(<ToastTemplate msg={msg} msgType={msgtype} />);
            }
        }
    }

    const update = () => toast.update(toastId.current, { type: toast.TYPE.ERROR, autoClose: 5000 });


    return { notify, update, toast };


    // return (
    //     <>
    //         {
    //             list.map((toast, i) =>
    //                 <div key={i} className={`alert ${getAlertType(toast.type)} has-icon alert-large`} role="alert">
    //                     <span className="has-icon"><i className={getDialogIcon(toast.type)}></i></span>
    //                     <div className="alert-content">
    //                         <h4>{toast.title}</h4>
    //                         <p>{toast.body}</p>
    //                     </div>
    //                 </div>)
    //         }
    //     </>
    //);
}










